






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '../../store';
import { IProject, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'project',
  }),
  mixins: [paginationMixin],
})
export default class ProjectList extends Vue {
  @Action('getEntities', { namespace: 'project' }) getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'project' })
  entitiesSlice: IProject[];
  @State('pageParams', { namespace: 'project' }) pageParams: IPageParams;
  selected = [];
  interval = null;
  headers = [
    { text: 'Название', value: 'name' },
    { text: 'Ссылка', value: 'link' },
  ];
  created() {
    this.getEntities();
  }
}
